import { render, staticRenderFns } from "./OfferKz.vue?vue&type=template&id=94d0ba00&"
import script from "./OfferKz.vue?vue&type=script&lang=js&"
export * from "./OfferKz.vue?vue&type=script&lang=js&"
import style0 from "./OfferKz.vue?vue&type=style&index=0&id=94d0ba00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports